import { render } from "./FormTaxAddress.vue?vue&type=template&id=8594f0d4"
import script from "./FormTaxAddress.vue?vue&type=script&lang=js"
export * from "./FormTaxAddress.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/vue-code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__